import * as type from './check-type';
import { destroyElem, destroyElemByKey } from './destroy';
import randomStr from './random-str';
import useHTMLString from './use-html-string';
import validComps from './validComps';
export { type, destroyElem, destroyElemByKey, randomStr, useHTMLString, validComps };
